import { useState } from "react";

import styles from "../../styles/input.module.scss";

import { EyeClosed, EyeOpen, InfoCircleGreen, InfoCircleGrey } from "./Icons";

import classNames from "classnames/bind";
import ReactInputMask from "react-input-mask";
import { If } from "./control-statements";

export const Input = ({
  design = "one",
  type,
  placeholder = " ",
  onChange,
  onBlur,
  onFocus,
  autoFocus,
  label,
  value,
  floatLabel,
  className = "",
  invalid,
  suffix,
  suffix2,
  defaultValue,
  onKeyUp,
  disabled,
  maxLength,
  max,
  min,
  mask,
  uppercase,
  filled = null,
  link,
  valid,
  readOnly,
  step,
  required,
  ...props
}) => {
  const cx = classNames.bind(styles);

  const { name } = props;
  const id = props.id || name;

  const [inputType, setInputType] = useState(type);

  return (
    <div className={`${styles.inputContainer} ${className}`}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div className={styles.input}>
        <ReactInputMask
          id={id}
          type={inputType}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          mask={mask || null}
          onFocus={onFocus}
          autoComplete="off"
          maskChar={null}
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          onKeyUp={onKeyUp}
          maxLength={maxLength || max}
          disabled={disabled}
          readOnly={readOnly}
          max={max}
          min={min}
          step={step}
          className={cx({
            invalid: invalid,
            password: inputType === "password",
            suffix: suffix,
            suffix2: suffix2,
            uppercase: uppercase,
            isLink: link,
            [`design-${design}`]: true,
          })}
          style={valid && link ? { color: "var(--default)" } : {}}
        />

        {floatLabel && (
          <label
            className={cx({
              float: true,
              invalid: invalid,
            })}
          >
            {floatLabel}
          </label>
        )}
        {design === "search" && (
          <div className={styles["search-field"]}>
            <i className="far fa-search"></i>
          </div>
        )}
        {type === "password" && (
          <span
            className={styles.eye}
            onClick={() =>
              setInputType(inputType === "password" ? "text" : "password")
            }
          >
            {inputType === "password" ? <EyeClosed /> : <EyeOpen />}
          </span>
        )}
        {suffix && <span className={styles.suffix}>{suffix}</span>}
        {suffix2 && <span className={styles.suffix2}>{suffix2}</span>}
        <If cond={link}>
          <div className={styles.link}>
            <svg
              width="13"
              height="10"
              viewBox="0 0 13 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7366 5.00022C12.6805 4.11031 12.6805 2.66866 11.7366 1.77876C10.7927 0.888852 9.26354 0.888852 8.31963 1.77876L7.89299 2.181C7.77594 2.29134 7.77594 2.47288 7.89299 2.58323C8.01003 2.69358 8.20259 2.69358 8.31963 2.58323L8.74628 2.181C9.45421 1.51357 10.602 1.51357 11.3099 2.181C12.0179 2.84842 12.0179 3.93055 11.3099 4.59798L8.95771 6.81385C8.25167 7.4795 7.10577 7.4795 6.39784 6.81385C5.72578 6.18023 5.68803 5.16574 6.30912 4.48941L6.40917 4.38084C6.51866 4.2616 6.50545 4.08183 6.37897 3.97861C6.25248 3.87538 6.06181 3.88783 5.95232 4.00708L5.85227 4.11565C5.02352 5.01802 5.07449 6.37067 5.96931 7.2143C6.91133 8.10243 8.44045 8.10243 9.38247 7.2143L11.7366 5.00022ZM1.48576 5.00022C0.541856 5.89012 0.541856 7.33177 1.48576 8.22168C2.42967 9.11158 3.95879 9.11158 4.9027 8.22168L5.32934 7.81944C5.44639 7.70909 5.44639 7.52755 5.32934 7.4172C5.2123 7.30685 5.01974 7.30685 4.9027 7.4172L4.47605 7.81944C3.76812 8.48687 2.62033 8.48687 1.91241 7.81944C1.20448 7.15201 1.20448 6.06988 1.91241 5.40245L4.26462 3.18659C4.97066 2.52094 6.11656 2.52094 6.82449 3.18659C7.49655 3.8202 7.53431 4.8347 6.91322 5.51102L6.81316 5.61959C6.70367 5.73884 6.71688 5.9186 6.84337 6.02183C6.96985 6.12506 7.16052 6.1126 7.27001 5.99335L7.37007 5.88478C8.19881 4.98242 8.14784 3.62976 7.25302 2.78613C6.30723 1.89445 4.77999 1.89445 3.83608 2.78257L1.48576 5.00022Z"
                fill={valid ? "var(--default)" : "#6F767E"}
                stroke={valid ? "var(--default)" : "#6F767E"}
                strokeWidth="0.5"
              />
            </svg>
          </div>
        </If>
        <If cond={filled !== null}>
          <div className={styles.filled}>
            <If cond={filled === false}>
              <InfoCircleGrey />
            </If>

            <If cond={filled === true}>
              <InfoCircleGreen />
            </If>
          </div>
        </If>
      </div>

      {invalid && <span className={styles.error} />}
    </div>
  );
};
